import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { SocialLink } from '@app/shared/interfaces/socialLink';
import { StaticJsonDataService } from '@app/shared/services/static-json-data-service';
import { Session } from 'protractor';

@Component({
  selector: 'app-callout-social',
  templateUrl: 'callout-social.component.html'
})
export class CalloutSocialComponent {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private staticJsonDataService: StaticJsonDataService
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  isBrowser = false;
  jsonFile: string = 'social.json';
  socialLinks: SocialLink[] = [];

  ngOnInit(): void {
    if (this.isBrowser) {
      this.setSocialLinks();
    }
  }

  setSocialLinks():void {
    this.staticJsonDataService
      .fetchJsonData(this.jsonFile)
      .then((jsonData:any) => {
        this.socialLinks = jsonData;
      });
  }
}
